import { fetchApi } from '@/app/api';
import { Work } from '@certhon/models';

export function fetchWorks(projectId?: number): Promise<Work[]> {
  return fetchApi('/works', projectId ? { projectId } : undefined);
}
export function fetchWork(workId: number): Promise<Work> {
  return fetchApi(`/works/${workId}` as '/works/:recnum');
}
